import {ServiceTypeEnum} from '@/services/api-clients';

export function invoiceServiceTypeColorFilter(type: ServiceTypeEnum) {
  switch(type) {
    case ServiceTypeEnum.Taxi: return 'yellow';
    case ServiceTypeEnum.Food: return 'primary';
  }
}
